module.exports = __webpack_public_path__ + "static/media/html.1d01a3fd.svg";